import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { BillingSubscription } from '@kawai/shared';
import { fetchAllBillingSubscriptions } from '../repositories/billingSubscriptions.js';

/**
 * TP-23: billing_subscriptions 全件（read 専用）の React Query hook。
 *
 * cache key は `['billing_subscriptions', 'all']`。cancel / resume mutation 成功時に
 * この key を invalidate して BillingPage の解約予約中バッジ / 再開ボタン活性を即時反映する。
 */
export function useBillingSubscriptions(): UseQueryResult<
  BillingSubscription[],
  Error
> {
  return useQuery({
    queryKey: ['billing_subscriptions', 'all'],
    queryFn: () => fetchAllBillingSubscriptions(),
  });
}
